import React from 'react'
import { NavLink } from 'react-router-dom'

export default function PostCard(props) {
  return (
    <div className = 'w-full lg:w-2/5 my-2 px-4'>
      <NavLink to = {`/thoughts/${props.post?.slug}`} className = 'text-black-50 font-code text-lg hover:underline underline-offset-4'>• {props.post?.title}</NavLink>
    </div>
  )
}